export default __webpack_public_path__ + "static/media/promocionAlarma2Mobile.a5638f84.png";